module.exports = "/assets/data/43e96b6c635b372d9b7313c589ccc8e5-BS8.data.json";